// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5299":"css/admin-app.6777","5726":"css/app.6777"}[chunkId] + ".css";
};